import { useRef } from 'react';

/**
 * Monotonic "preview session" id for the checkout preview hooks. (T-375)
 *
 * `keepPreviousData` keeps the last discount visible across edits to the SAME cart (T-369),
 * but it also survives the query being disabled — so after the cart empties (or the loyalty
 * request is cleared / the customer changes) the NEXT cart's first fetch would briefly show
 * the PRIOR cart's discount. The id is bumped when the preview goes inactive (or its scope changes);
 * folding it into the query key lets `placeholderData` carry a previous value only when it
 * belongs to the same session.
 */
export function usePreviewSession(active: boolean, scope = ''): string {
  const counter = useRef(0);
  const wasActive = useRef(false);
  const lastScope = useRef(scope);
  if ((wasActive.current && !active) || lastScope.current !== scope) {
    counter.current += 1;
  }
  wasActive.current = active;
  lastScope.current = scope;
  return `${counter.current}:${scope}`;
}
